<div *ngIf="!HModel.IsPageLoaded; else populated;">
  <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/loader/loading-page.gif" style="padding: 10% 35%;">
</div>
<ng-template #populated>
  <div class="cManikPopupWidth">
    <div class="main-content">
      <div class="cPopupContainer">
        <div [ngClass]="{'cPopupSidebar': HModel.ShowSectionList,'cPopupSidebarNarrow': !HModel.ShowSectionList}">
          <div class="cPopupMenu1">
            <ul class="nav">
              <li>
                <a matTooltip="Page settings" [matTooltipPosition]="'right'" (click)="PopulateMenu2('Page')">
                  <i class="fa fa-file-text" [ngClass]="{'active': HMenuModel.IsPageSettingActive}"></i>
                </a>
              </li>
              <li *ngIf="HModel.MicroPageID">
                <a matTooltip="Paragraph settings" [matTooltipPosition]="'right'" (click)="PopulateMenu2('Section')">
                  <i class="fa fa-paragraph" [ngClass]="{'active': HMenuModel.IsParagraphSettingActive}"></i>
                </a>
              </li>
            </ul>
            <ul class="nav cPopupLowerUL">
              <li>
                <a matTooltip="Effects" [matTooltipPosition]="'right'" (click)="PopulateMenu2('Effects')">
                  <i class="fa fa-magic" [ngClass]="{'active': HMenuModel.IsEffectsActive}"></i>
                </a>
              </li>
              <li *ngIf="HModel.EditBackground">
                <a matTooltip="Background" [matTooltipPosition]="'right'" (click)="PopulateMenu2('Background')">
                  <i class="material-icons" [ngClass]="{'active': HMenuModel.IsBackgroundActive}">pages</i>
                </a>
              </li>
            </ul>
          </div>
          <div [ngClass]="{'cPopupMenu2': HModel.ShowSectionList, 'cPopupMenu2Hidden': !HModel.ShowSectionList}">
            <ul class="sub-menu cDrgSubMenu" *ngIf="HModel.ShowSectionList" cdkDropList
              [cdkDropListData]="HModel.SectionData" (cdkDropListDropped)="drop($event)">
              <li class="nav-link" (click)="AddASection()">
                <a class="nav-link cSectionAnchor">
                  <div class="cSectionText cAddSection">
                    Add A Section
                  </div>
                  <div class="cSectionIcon">
                    <i class="material-icons">add_circle_outline</i>
                  </div>
                </a>
              </li>
              <li *ngFor="let item of HModel.SectionData; let i = index;" class="nav-link cTDragDropBox cSubMenuDrag"
                cdkDrag [cdkDragData]="item">
                <div class="cTDragDropPlaceHolder" *cdkDragPlaceholder></div>
                <a class="nav-link cSectionAnchor" id="{{'submenu' + item.SmallContentID}}">
                  <div class="cSectionText" (click)="OnSelectSection(item)">
                    <i class="{{item.ContentIconText}}"></i>
                    {{item.ContentHeader.toLowerCase()}}
                  </div>
                  <div class="cSectionIcon">
                    <i class="material-icons">open_with</i>
                    <i class="material-icons" style="cursor:pointer;"
                      (click)="DeleteSection(item.SmallContentID);">delete_forever</i>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div
          [ngClass]="{'cPopupMainPanel': HModel.ShowSectionList, 'cPopupMainPanelExpanded': !HModel.ShowSectionList}">
          <div class="cPopupWorkSpace" *ngIf="HModel.ShowPageSettings">
            <form [formGroup]="PageForm">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="cDefault">
                      <h5>Header</h5>
                      <!-- <input type="text" formControlName="PageHeaderText"> -->
                      <angular-editor (focus)="showToolBar(0);" (blur)="hideToolBar()" [config]="editorConfig"
                        formControlName="PageHeaderText"></angular-editor>
                    </div>
                    <div class="cDefault">
                      <h5>Slogan</h5>
                      <!-- <input type="text" formControlName="PageSloganText"> -->
                      <angular-editor (focus)="showToolBar(1);" (blur)="hideToolBar()" [config]="editorConfig"
                        formControlName="PageSloganText"></angular-editor>
                    </div>
                    <div class="cDefault">
                      <h5>Description</h5>
                      <!-- <textarea formControlName="PageDescription"></textarea> -->
                      <angular-editor (focus)="showToolBar(2);" (blur)="hideToolBar()" [config]="editorConfig"
                        formControlName="PageDescription"></angular-editor>
                    </div>
                    <manik-smart-button *ngIf="HModel.ShowPageSmartButton" [SBParams]="HModel.SBParams">
                    </manik-smart-button>

                    <input type="hidden" formControlName="ReservedIdentifier">
                    <input type="hidden" formControlName="BusinessID">
                    <input type="hidden" formControlName="IsActive">
                    <input type="hidden" formControlName="SectionTypeID">
                  </div>
                  <div class="col-md-6" *ngIf="HModel.ShowPageSmartMedia">
                    <image-handler [ImageData]="HModel.ImageDataPageMedia"></image-handler>
                  </div>
                </div>
              </div>
            </form>
            <div class="cPopupAction">
              <button class="cButtonPopupSubmit" (click)="SubmitPageSettings($event)"></button>
            </div>
          </div>
          <div class="cPopupWorkSpace" *ngIf="HModel.ShowSectionList">
            <form [formGroup]="SectionForm" #sectionFrm="ngForm">
              <div class="row col-md-12">
                <div class="col-md-5">
                  <div class="cDefault">
                    <h5>Header</h5>
                    <input type="text" formControlName="ContentHeader">
                  </div>
                  <div class="cDefault">
                    <h5>Sub Header</h5>
                    <input type="text" formControlName="ContentSubHeader">
                  </div>
                  <div class="cDefault">
                    <h5>Description</h5>
                    <textarea formControlName="ContentText"></textarea>
                  </div>
                  <manik-smart-button *ngIf="HModel.IsPageLoaded" [SBParams]="HModel.SParams"></manik-smart-button>
                </div>
                <div class="col-md-7" *ngIf="HMenuModel.IsSectionEdit">
                  <image-handler *ngIf="HModel.IsPopulated" [ImageData]="HModel.ImageDataSectionMedia">
                  </image-handler>
                </div>
              </div>
            </form>
            <div class="cPopupAction">
              <button class="cButtonPopupSubmit" *ngIf="!FormSubmitted" (click)="SubmitSectionSettings()"></button>
              <ManikButtonLoader *ngIf="FormSubmitted"></ManikButtonLoader>
            </div>
          </div>
          <div class="cPopupWorkSpace cBackgroundMediaSettings" *ngIf="HModel.ShowBackgroundSettings">
            <form>
              <image-handler [ImageData]="HModel.ImageDataBGMedia"></image-handler>
            </form>
          </div>

          <div class="cPopupWorkSpace" *ngIf="HModel.AddEffects">
            <form [formGroup]="EffectForm" #rftForm="ngForm">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="cMatdd_main"
                      [ngClass]="{'cMatdd_error': frmEft.SelectedEffectID.invalid && (frmEft.SelectedEffectID.touched || rftForm.submitted),'cMatdd_success': frmEft.SelectedEffectID.valid && frmEft.SelectedEffectID.dirty}">
                      <h5>Effects</h5>
                      <mat-select placeholder="Choose Effect" formControlName="SelectedEffectID">
                        <mat-option *ngFor="let item of DesignerEffects" [value]="item.DataValue">{{item.DataText}}
                        </mat-option>
                      </mat-select>
                      <span *ngIf="rftForm.submitted && frmEft.SelectedEffectID.errors" class="cErrorMsg">
                        <span *ngIf="frmEft.SelectedEffectID.errors.required">
                          *required</span>
                      </span>
                    </div>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </form>
            <div class="cPopupAction">
              <button class="cButtonPopupSubmit" (click)="SubmitPageEffect($event)"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
